import type { DimensionId } from "@benyishiguang/ui-foundation";
import type { Practice } from "./types";
export const getFeaturedPracticesByDimension = (practices: Practice[], dimensionId: DimensionId) =>
	practices
		.filter((practice) => practice.directoryFeatured && practice.dim === dimensionId)
		.sort(
			(left, right) =>
				(left.directoryRank ?? Number.MAX_SAFE_INTEGER) -
				(right.directoryRank ?? Number.MAX_SAFE_INTEGER),
		);
